import React, { useState } from "react";
import { Helmet } from "react-helmet";
import FormBeneficiarios from "../../components/paet/FormBeneficiarios";
import ayuda from "../../assets/img/ayuda.png";
import BeneficiarioModal from "../../components/paet/BeneficiarioModal";

export default function Beneficiario() {

    const [modalShow, setModalShow] = useState(false);
    const handleShow = () => setModalShow(true);
    const handleClose = () => setModalShow(false);

    return (
        <>
            <Helmet>
                <title>Retiro Enfermos Terminales AFP Modelo | Solicitud de Retiro Enfermos Terminales | AFP Modelo</title>
                <meta name="description" content={``} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <section>
                <div className="container">
                    <div className="card formulario mt-5 mb-5">
                        <div className="card-header">
                            <div className="form-row">
                                <div className="titulo">
                                    Retiro de Pensión Anticipada por Enfermedad Terminal (PAET)
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="subtitulo mt-3">
                                    Ingresar datos de Beneficiarios {" "}
                                    <a className="text-decoration-none align-svg" onClick={handleShow}>
                                        <img className="icon ayuda" src={ayuda} alt="ayuda" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="card-body paet">
                            <FormBeneficiarios />
                            <BeneficiarioModal show={modalShow} onHide={handleClose} />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}